export const requisitionsReport = {
  id: 3091,
  name: 'Requisitions',
  description: '',
  visibility: 'private',
	subject_type: 'requisitions',
  layout: {
    data: [
      {
        h: 7,
        w: 3,
        x: 0,
        y: 0,
        key: '7435',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 3,
        y: 0,
        key: '7436',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 6,
        y: 0,
        key: '7437',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 9,
        y: 0,
        key: '7438',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 24,
        w: 12,
        x: 0,
        y: 7,
        key: '7487',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 0,
        y: 31,
        key: '7488',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 6,
        y: 31,
        key: '7489',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 12,
        x: 0,
        y: 54,
        key: '7490',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 77,
        key: '7491',
        maxH: 100,
        maxW: 12,
        minH: 10,
        minW: 8,
      },
    ],
  },
  filters: null,
  tiles: [
    {
      id: 7435,
      subject_type: 'requisitions',
      metadata: {
        id: 'requisitions_opened',
        tileKey: 'requisitions_opened',
        apiParam: 'card',
        headerKey: 'requisitions_opened',
        componentType: 'card',
        uniqueTrackingId: 'requisitions_1761640608898_3ark47hqb',
      },
      query: null,
    },
    {
      id: 7436,
      subject_type: 'requisitions',
      metadata: {
        id: 'requisitions_filled',
        tileKey: 'requisitions_filled',
        apiParam: 'card',
        headerKey: 'requisitions_filled',
        componentType: 'card',
        uniqueTrackingId: 'requisitions_1761640608898_x0md09nbm',
      },
      query: null,
    },
    {
      id: 7437,
      subject_type: 'requisitions',
      metadata: {
        id: 'requisitions_closed',
        tileKey: 'requisitions_closed',
        apiParam: 'card',
        headerKey: 'requisitions_closed',
        componentType: 'card',
        uniqueTrackingId: 'requisitions_1761640608898_claq433gt',
      },
      query: null,
    },
    {
      id: 7438,
      subject_type: 'requisitions',
      metadata: {
        id: 'total_time_to_fill',
        unit: 'time',
        tileKey: 'total_time_to_fill',
        apiParam: 'card',
        metricKeys: {
          numerator: 'total_time_to_fill',
          denominator: 'requisitions_filled',
        },
        componentType: 'card',
        calculationType: 'avgChange',
        uniqueTrackingId: 'requisitions_1761640608898_3l1gjymg3',
      },
      query: null,
    },
    {
      id: 7487,
      subject_type: 'requisitions',
      metadata: {
        id: 'requisitions_trend_chart',
        tileKey: 'requisitions_trend_chart',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
        uniqueTrackingId: 'requisitions_1761731930435_4ny490t9x',
      },
      query: null,
    },
    {
      id: 7488,
      subject_type: 'requisitions',
      metadata: {
        id: 'requisitions_by_department',
        tileKey: 'requisitions_by_department',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'department',
        },
        uniqueTrackingId: 'requisitions_1761731930436_oacvxbvog',
      },
      query: null,
    },
    {
      id: 7489,
      subject_type: 'requisitions',
      metadata: {
        id: 'requisitions_by_requisition_type',
        tileKey: 'requisitions_by_requisition_type',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'requisition_type',
        },
        uniqueTrackingId: 'requisitions_1761731930436_mctgask6w',
      },
      query: null,
    },
    {
      id: 7490,
      subject_type: 'requisitions',
      metadata: {
        id: 'requisitions_by_department_pie',
        tileKey: 'requisitions_by_department_pie',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'department',
        },
        uniqueTrackingId: 'requisitions_1761731930436_xr2jwwxh4',
      },
      query: null,
    },
    {
      id: 7491,
      subject_type: 'requisitions',
      metadata: {
        id: 'requisitions_table',
        tileKey: 'requisitions_table',
        title: 'Requisitions',
        apiParam: 'chart_table',
        headerKeys: [
          'requisitions_opened',
          'requisitions_closed',
          'time_to_fill',
        ],
        componentType: 'table',
        uniqueTrackingId: 'requisitions_1761731930436_a8bnhhvc9',
      },
      query: null,
    },
  ],
  user: {
    id: 2308,
  },
};
